// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"History_wrapper__3EhD6","txStatuses":"History_txStatuses__15lXQ"};